export default __webpack_public_path__ + "static/media/info_1.3c34878a.svg";